export default {
	"order.ShoppingMallPaymentResultPageAdvertisingPopUpWindow": "商城支付结果页_广告弹窗",
	"order.ParameterError": "参数错误!",
	"order.ForMoreInformationYouCanLogInToTheCallAppletOrAppToFollow": "更多信息，可登录【叫叫】小程序或app进行关注。",
	"order.checkOrder": "查看订单",
	"order.share": "分享",
	"order.LongPressToIdentifyTheQRCode": "长按识别二维码",
	"order.EnterTheCallApplet": "进入叫叫小程序",
	"order.MallPaymentResultPageAdPopUpWindowClick": "商城支付结果页_广告弹窗点击"
}